import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { AccountCertificate } from '@/modules/AccountCertificate/interfaces/account-certificate'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import AccountCertificateForm from '@/modules/AccountCertificate/components/AccountCertificateForm.vue'
import { deleteAccountCertificate } from '@/modules/AccountCertificate/gql/account-certificate.gql'

@Component({
  components: {
    AppDialog,
    AccountCertificateForm
  }
})
export default class AccountCertificateDialog extends Vue {
  targetAccountCertificate: AccountCertificate | null = null

  accountCertificateDialog = {
    actionType: 'new',
    show: false,
    title: 'New Certificate',
    disable: false
  }

  deleteAccountCertificateDialog = {
    show: false,
    title: 'Delete Certificate',
    text: ''
  }

  showAccountCertificateEditDialog (e: Event, targetAccountCertificate?: AccountCertificate) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Certificate'
    if (targetAccountCertificate && targetAccountCertificate.id !== -1) {
      this.targetAccountCertificate = targetAccountCertificate
      actionType = 'edit'
      title = 'Edit Certificate'
    }
    this.accountCertificateDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideAccountCertificateEditDialog () {
    this.targetAccountCertificate = null
    this.accountCertificateDialog = {
      actionType: 'new',
      show: false,
      title: 'New AccountCertificate',
      disable: false
    }
  }

  async deleteAccountCertificate (e: Event, accountCertificate: AccountCertificate) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAccountCertificate = accountCertificate
    this.deleteAccountCertificateDialog.show = true
  }

  async deleteAccountCertificatePost () {
    if (!this.targetAccountCertificate) {
      return
    }
    const { id } = this.targetAccountCertificate
    this.deleteAccountCertificateDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteAccountCertificate,
        variables: {
          accountCertificateId: Number(id)
        }
      })

      const res = result.data.deleteAccountCertificate
      if (res) {
        showNotification({
          msg: 'Delete accountCertificate successfully',
          type: SnackType.Success
        })
        this.targetAccountCertificate = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
